import MuiCircularProgress from "@mui/material/CircularProgress";

export const CircularProgress = (props) => {
  return <MuiCircularProgress {...props} />;
};
